import { z } from 'zod';

export const getAssortmentDetailsSchema = z.array(
  z.object({
    id: z.string(),
    assortmentID: z.string(),
    bindingID: z.string(),
    description: z.string(),
    mustHave: z.boolean().optional(),
    isFromManager: z.boolean(),
    similarID: z.string().optional(),
    isActive: z.boolean(),
    minQuantity: z.number().optional(),
  })
);

export type GetAssortmentsResponse = z.infer<typeof getAssortmentDetailsSchema>;
